import React from "react";

const VendorOrdersModule = React.lazy(() => import("./ui/VendorOrders"));

export const VendorOrdersPage = () => {
  return <VendorOrdersModule />;
};
